import { render, staticRenderFns } from "./TagsEdit.vue?vue&type=template&id=5c234bd8&"
import script from "./TagsEdit.vue?vue&type=script&lang=js&"
export * from "./TagsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports